import { render, staticRenderFns } from "./weChatTemplateList.vue?vue&type=template&id=4e557c5d&scoped=true&"
import script from "./weChatTemplateList.vue?vue&type=script&lang=js&"
export * from "./weChatTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./weChatTemplateList.vue?vue&type=style&index=0&id=4e557c5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e557c5d",
  null
  
)

export default component.exports